mutation PayCycleUploadDocument(
  $document: DocumentUploadInput!
  $payCycleId: UUID!
) {
  payCycleUploadDocument(document: $document, payCycleId: $payCycleId) {
    uploadLink
    document {
      _documentFileId
      payCycleDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
    }
  }
}
